import Component from 'vue-class-component'
import { Mixins } from 'vue-property-decorator'
import axios from 'axios'
import SnackbarService from './snackbar-service';
import { Cow } from '@/interfaces/Cow';

@Component
class ApiService extends Mixins(SnackbarService) {

  getAllCowsUpdateCache() {
    if (navigator.onLine) {
      axios
        .get('/cows-all')
        .then(res => {
          // delete index db and insert all new
          this.$db.cows.clear().then(() => {
            this.$db.cows.bulkPut(res.data)
          })
        })
        .catch((error: any) => {
          if (error && error.response && error.response.status !== 401) {
            this.notify({ text: `Server error. ${error}` })
          }
        })
    }
  }

  fetchCowIdsAndNumbers() {
    const cowIdsAndNumbers: { value: string; text: string }[] = [
      { value: null, text: 'Sin' },
    ]
    if (navigator.onLine) {
      return axios
        .get(`/cow-ids-numbers`)
        .then(res => {
          res.data.forEach((c: any) => {
            cowIdsAndNumbers.push({ value: c.id, text: c.number })
          })
          return cowIdsAndNumbers
        })
        .catch(error => {
          this.notify({ text: `Server error. ${error}` })
          this.$store.state.loading = false
        })
    } else {
      const cowIdsAndNumbers = []
      return this.$db.cows.toArray().then((cows: Cow[]) => {
        cows.forEach((cow: Cow) => {
          cowIdsAndNumbers.push({ value: cow.id, text: cow.number })
        })
        return cowIdsAndNumbers
      })
    }
  }
  
}
export default ApiService
